
export default {
  cropsYieldEvolutionContext: new Map(),
  cropYieldEvolutionStatus: new Map(),
};
